module.exports = __webpack_public_path__ + "static/qr-code-a80416fd61b9485770385df6a1b83b61.png";